import { Spinner, useIntl } from "@metsooutotec/modes-react-components"
import { FC } from "react";

interface LowSpinnerProps {
    id: string
}

const LowSpinner: FC<LowSpinnerProps> = ({ id }) => {
    const { formatMessage } = useIntl();
    return <Spinner text={formatMessage(id)} style={{ zIndex: 8 }} />
}

export default LowSpinner;